import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import {
  faUserCircle,
  faClock,
  faUsers,
  faChartArea,
  faTasks,
  faRocket,
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';

/**
 * Agents list page under the home section.
 */
export const Agencies = () => {
  return (
    <>
      <Helmet>
        <title>For Agencies</title>
      </Helmet>
      <div className="intro">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-5 mt-5">
            <Col lg={12}>
              <h1 className="text-center fw-bold mt-5 text-white">Agency Management</h1>
              <div className="header-divider" />
              <p className="text-center mt-4 mb-5 px-5 text-white">
                A seamless ecosystem for agencies and downlines.
              </p>
            </Col>
            <Col lg={12} className="text-center">
              <img src="/assets/home/agencies/intro.png" className="w-50" />
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="max-w-xl pb-5">
        <Row className="pt-5 pb-5">
          <Col lg={12} className="pt-5">
            <h1 className="text-center fw-bold mt-5">Instant Information</h1>
            <div className="header-divider" />
            <p className="text-center mt-4 mb-5 px-5">
              With one CRM ecosystem you have instant insight and access to agent production.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faUserCircle} />
            <h5 className="fw-bold">Agent Profiles</h5>
            <p>
              It's easy to onboard agents into MedicarePRO with your custom invite links. Once
              downlines are in you can start managing like a pro.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faClock} />
            <h5 className="fw-bold">Pending Production</h5>
            <p>
              The moment your DL writes business you'll be able to see what they sold and what you
              make on the policy. You define override amounts for each agent level and company.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faUsers} />
            <h5 className="fw-bold">Leads</h5>
            <p>
              If you generate lead opportunities for your agents, you can create and assign those to
              agents right from the leads page. Then keep track of the outcome and reassign if
              needed.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faChartArea} />
            <h5 className="fw-bold">Contracts & Overrides</h5>
            <p>
              We make it easy for you to store agent company contract details in the system. Once
              you add override schedules MedicarePro does the override calculations for you.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faTasks} />
            <h5 className="fw-bold">Activities</h5>
            <p>
              Assign activities to DL's and track the progress. With a build in messaging feature,
              you can correspond on the details.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faRocket} />
            <h5 className="fw-bold">Reporting</h5>
            <p>
              Get an in-depth look at your agencies production and run agent sales reports for any
              date range you wish.
            </p>
          </Col>
        </Row>
      </Container>

      <div className="bg-white">
        <Container className="max-w-xl py-5">
          <h1 className="text-center fw-bold mt-5">Custom Branding</h1>

          <Row className="mt-5 mb-5">
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Your agency, your look</h5>
              <p>
                You can upload your agency logo from the platform, then edit it so it looks just
                right. Now all of your downlines will see your company on their CRM.
              </p>
            </Col>
            <Col lg={6}>
              <img src="/assets/home/agencies/custombranding.png" className="w-100 shadow-m" />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="bg-brand">
        <Container className="max-w-xl py-5">
          <h1 className="text-center fw-bold mt-5">Agent & Agency Documents</h1>

          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agencies/documents.png" className="w-100 shadow-m" />
            </Col>
            <Col lg={6}>
              <h5 className="fw-bold">Store Securely</h5>
              <p>
                Our robust document storage platform gives you a central hub for all things agency
                related. As an agency member you can create document directories then share them
                with your downlines. Or keep docs private for internal use only. Our cloud storage
                through Amazon AWS means your documents are encrypted and secure.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="max-w-xl py-5">
        <h1 className="text-center fw-bold mt-5">Interactive Dashboard</h1>

        <Row className="mt-5 mb-5">
          <Col lg={6} className="pt-5">
            <h5 className="fw-bold">Quick Metrics</h5>
            <p>
              Your agency dashboard gives you a quick peek at important production metrics. You can
              also track leads outcomes and visualize your downline hierarchy.
            </p>
          </Col>
          <Col lg={6}>
            <img src="/assets/home/agencies/dashboard.png" className="w-100 shadow-m" />
          </Col>
        </Row>
      </Container>

      <div className="bg-white">
        <Container className="max-w-xl py-5">
          <h1 className="text-center fw-bold mt-5">Agency Links</h1>

          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agencies/links.png" className="w-100 shadow-m" />
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Keep 'em connected</h5>
              <p>
                We really give you the tools to give your agents... the tools. Choose from our
                depository of company links or make your own to share with your downlines. These can
                be links to anything, agent trainings, your website, etc.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="max-w-xl pt-5 pb-5 text-center">
        <h1 className="text-center fw-bold mt-5">Give it a try</h1>
        <div className="header-divider" />
        <p className="text-center mt-4 mb-5 px-5 lead">
          We give you 30 days to try out MedicarePRO with unlimited access. No card info, no
          contracts.
        </p>
        <NavLink className="btn btn-primary" to="/home/sign-up" end>
          Start Free Trial
        </NavLink>
      </Container>
    </>
  );
};
